export default {"src":"/_next/static/media/3.8a50bb14.svg","height":82,"width":76,"blurWidth":0,"blurHeight":0};